export const getViewIds = (data: { value: { entityId: number }[] }[]) => new Set<number>(Object.values(data)?.[0]?.value?.map(o => o.entityId) ?? []);

export const getListingIds = (data: { value: { listingId: number }[] }[]) => new Set<number>(Object.values(data)?.[0]?.value?.map(o => o.listingId) ?? []);